import { FC } from 'react';
import { useTranslation, Trans } from 'next-i18next';
import Image from 'next/image';
import { PATHS, NEXT_STATIC_IMAGES } from 'src/common/constants';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import Typography from 'src/common/components/Typography';
import Button from 'src/common/components/ButtonDS22';
import styles from './Hero.module.scss';

const Hero: FC = () => {
  const [t] = useTranslation('for-owners-page');

  return (
    <PitchPageLayout
      backgroundColor="ivory"
      variant="header"
    >
      <div className={styles.root}>
        <Image
          src={`${NEXT_STATIC_IMAGES}for-owners/hero-graphic.svg`}
          width={151}
          height={80}
          alt={t('hero--graphic--alt')}
          loading="eager"
        />
        <div className={styles.title}>
          <Typography
            type="h1"
            size="display-4"
            sizeFromBreakpointM="display-3"
          >
            <Trans
              t={t}
              i18nKey="hero--title"
              components={{
                break: (
                  <br className={styles.break} />
                ),
              }}
            />
          </Typography>
        </div>
        <div className={styles.text}>
          <Typography type="p" size="body-xl">
            {t('hero--text')}
          </Typography>
        </div>
        <Button
          type="link"
          href={PATHS.ADMIN_LISTINGS}
          variant="primary-blue"
          fitWidth="m"
        >
          <Typography
            size="body-xl"
            type="p"
            weight="semibold"
          >
            {t('button--get-started')}
          </Typography>
        </Button>
      </div>
    </PitchPageLayout>
  );
};

export default Hero;
